<template>
    <div class="ma-5">
        <v-data-table
            :headers="headers"
            :items="desserts"
            :height="320"
            :search="search"
            :fixed-header="true"
            class="elevation-3"
        >
            <template v-slot:top>
                <v-toolbar flat color="white">
                    <v-toolbar-title>Cadastro de Permissões</v-toolbar-title>
                    <v-divider
                        class="mx-4"
                        inset
                        vertical
                    ></v-divider>
                    <v-spacer></v-spacer>

                    <v-text-field class="mr-10"
                        v-model="search"
                        append-icon="mdi-magnify"
                        label="Pesquisar"
                        single-line
                        hide-details
                    ></v-text-field>

                    <v-dialog persistent v-model="dialog" max-width="600px">
                        <template v-slot:activator="{ on }">
                            <v-btn color="primary" dark class="mb-2" v-on="on">Novo</v-btn>
                        </template>
                        <v-card>
                            <v-card-title>
                                <span class="headline">{{ formTitle }}</span>
                            </v-card-title>
                            <v-card-text>
                                <v-container>
                                    <v-row>
                                        <v-col class="pa-0" cols="12" xs="12">
                                            <v-autocomplete
                                                v-model="editedItem.idperfil"
                                                :items="selects.perfil.items"
                                                label="Digite o nome Perfil"
                                                clearable
                                                outlined
                                                color="#042333"
                                                item-text="descricao_perfil"
                                                item-value="idperfil"
                                                :error-messages="perfilErrors"
                                                @input="$v.editedItem.idperfil.$touch()"
                                                @blur="$v.editedItem.idperfil.$touch()"
                                            >
                                            </v-autocomplete>
                                        </v-col>
                                        <v-col class="pa-0" cols="12" md="12">
                                            <v-autocomplete
                                                v-model="editedItem.idaplicativo"
                                                :items="selects.aplicativo.items"
                                                label="Digite o nome Aplicativo"
                                                clearable
                                                outlined
                                                item-text="descricao_aplicativo"
                                                item-value="idaplicativo"
                                                :error-messages="aplicativoErrors"
                                                @input="$v.editedItem.idaplicativo.$touch()"
                                                @blur="$v.editedItem.idaplicativo.$touch()"
                                            >
                                            </v-autocomplete>
                                        </v-col>
                                        <v-col class="pa-0" cols="12" md="3">
                                            <v-select
                                                v-model="editedItem.view"
                                                :items="selects.view.items"
                                                chips
                                                label="View"
                                                height="10"
                                                outlined
                                                item-value="id"
                                                item-text="value"
                                                :error-messages="viewErrors"
                                                @input="$v.editedItem.view.$touch()"
                                                @blur="$v.editedItem.view.$touch()"
                                            ></v-select>
                                        </v-col>
                                        <v-col class="pa-0" cols="12" md="3">
                                            <v-select
                                                v-model="editedItem.add"
                                                :items="selects.add.items"
                                                chips
                                                label="Add"
                                                height="10"
                                                outlined
                                                item-value="id"
                                                item-text="value"
                                                :error-messages="addErrors"
                                                @input="$v.editedItem.add.$touch()"
                                                @blur="$v.editedItem.add.$touch()"
                                            ></v-select>
                                        </v-col>
                                        <v-col class="pa-0" cols="12" md="3">
                                            <v-select
                                                v-model="editedItem.edit"
                                                :items="selects.edit.items"
                                                chips
                                                label="Edit"
                                                height="10"
                                                outlined
                                                item-value="id"
                                                item-text="value"
                                                :error-messages="editErrors"
                                                @input="$v.editedItem.edit.$touch()"
                                                @blur="$v.editedItem.edit.$touch()"
                                            ></v-select>
                                        </v-col>
                                        <v-col class="pa-0" cols="12" md="3">
                                            <v-select
                                                v-model="editedItem.del"
                                                :items="selects.del.items"
                                                chips
                                                label="Del"
                                                height="10"
                                                outlined
                                                item-value="id"
                                                item-text="value"
                                                :error-messages="delErrors"
                                                @input="$v.editedItem.del.$touch()"
                                                @blur="$v.editedItem.del.$touch()"
                                            ></v-select>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="blue darken-1" text @click="close">Sair</v-btn>
                                <v-btn color="blue darken-1" text @click="save">Salvar</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-toolbar>
            </template>
            <template v-slot:item.action="{ item }">
                <v-icon
                    title="Editar Permissões"
                    class="mr-2"
                    @click="editItem(item)"
                >
                    mdi-pencil
                </v-icon>
                <v-icon
                    title="Remover Permissões"
                    @click="deleteItem(item)"
                >
                    mdi-delete
                </v-icon>
            </template>
        </v-data-table>
    </div>
</template>
<script>
    import {required} from 'vuelidate/lib/validators'
    import AclAPI from "./../../api/acl";

    export default {
        props: ['atualizarPerm'],
        data: () => ({
            dialog: false,
            search:'',
            headers: [
                {
                    text: 'ID Perfil',
                    value: 'idperfil',
                },
                {
                    text: 'Perfil',
                    align: 'left',
                    value: 'descricao_perfil',
                },
                {
                    text: 'ID Aplicativo',
                    value: 'idaplicativo',
                },
                {
                    text: 'Aplicativo',
                    align: 'left',
                    value: 'descricao_aplicativo',
                },
                {text: 'View', value: 'view'},
                {text: 'Add', value: 'add'},
                {text: 'Edit', value: 'edit'},
                {text: 'Del', value: 'del'},
                {text: 'Ações', value: 'action', sortable: false},
            ],
            desserts: [],
            editedIndex: -1,
            selects: {
                perfil: {
                    items: [],
                },
                aplicativo: {
                    items: [],
                },
                add: {
                    items: [
                        {
                            id: 'S',
                            value: 'SIM'
                        },
                        {
                            id: 'N',
                            value: 'NÃO'
                        }
                    ],
                },
                del: {
                    items: [
                        {
                            id: 'S',
                            value: 'SIM'
                        },
                        {
                            id: 'N',
                            value: 'NÃO'
                        }
                    ],
                },
                edit: {
                    items: [
                        {
                            id: 'S',
                            value: 'SIM'
                        },
                        {
                            id: 'N',
                            value: 'NÃO'
                        }
                    ],
                },
                view: {
                    items: [
                        {
                            id: 'S',
                            value: 'SIM'
                        },
                        {
                            id: 'N',
                            value: 'NÃO'
                        }
                    ],
                },
            },
            editedItem: {
                idaplicativo: '',
                idperfil: '',
                add: '',
                del: '',
                edit: '',
                view: '',

            },
            defaultItem: {
                idaplicativo: '',
                idperfil: '',
                add: '',
                del: '',
                edit: '',
                view: '',

            },
        }),

        validations: {
            editedItem: {
                idaplicativo: {
                    required,

                },
                idperfil: {
                    required,

                },
                add: {
                    required
                },
                del: {
                    required,
                },
                edit: {
                    required,
                },
                view: {
                    required,
                }
            }
        },
        computed: {
            perfilErrors() {
                const errors = []
                if (!this.$v.editedItem.idperfil.$dirty) return errors
                !this.$v.editedItem.idperfil.required && errors.push('Campo Obrigatório.')
                return errors
            },
            aplicativoErrors() {
                const errors = []
                if (!this.$v.editedItem.idaplicativo.$dirty) return errors
                !this.$v.editedItem.idaplicativo.required && errors.push('Campo Obrigatório.')
                return errors
            },
            addErrors() {
                const errors = []
                if (!this.$v.editedItem.add.$dirty) return errors
                !this.$v.editedItem.add.required && errors.push('Campo Obrigatório.')
                return errors
            },
            delErrors() {
                const errors = []
                if (!this.$v.editedItem.del.$dirty) return errors
                !this.$v.editedItem.del.required && errors.push('Campo Obrigatório.')
                return errors
            },
            editErrors() {
                const errors = []
                if (!this.$v.editedItem.edit.$dirty) return errors
                !this.$v.editedItem.edit.required && errors.push('Campo Obrigatório.')
                return errors
            },
            viewErrors() {
                const errors = []
                if (!this.$v.editedItem.view.$dirty) return errors
                !this.$v.editedItem.view.required && errors.push('Campo Obrigatório.')
                return errors
            },

            formTitle() {
                return this.editedIndex === -1 ? 'Novo Permissão' : 'Editar Permissão'
            },
        },

        watch: {
            dialog(val) {
                val || this.close()
            },
            atualizarPerm(){
                this.initialize()
            }
        },

        created() {
            this.initialize()
        },

        methods: {
            initialize() {

                const headers = this.Helpers.iniciarRequisicao();

                AclAPI.getPerfis(headers)
                    .then(response => {

                        const token = response.data.token;
                        localStorage.setItem('token', token);

                        if (response.status == 200) {

                            this.selects.perfil.items = response.data.perfis;

                        }

                    })
                    .catch(() => {
                        this.Helpers.logout();
                    })

                AclAPI.getAplicativos(headers)
                    .then(response => {

                        const token = response.data.token;
                        localStorage.setItem('token', token);

                        if (response.status == 200) {

                            this.selects.aplicativo.items = response.data.aplicativos;

                        }

                    })
                    .catch(() => {
                        this.Helpers.logout();
                    })

                AclAPI.getPermissoes(headers)
                    .then(response => {

                        const token = response.data.token;
                        localStorage.setItem('token', token);

                        if (response.status == 200) {

                            this.desserts = response.data.grants;

                        }

                    })
                    .catch(() => {
                        this.Helpers.logout();
                    })

                this.$store.dispatch("loading/habilitarLoading", false);

            },

            editItem(item) {
                this.editedIndex = this.desserts.indexOf(item)
                this.editedItem = Object.assign({}, item)
                this.dialog = true
            },

            deleteItem(item) {

                this.editedItem = Object.assign({}, item)

                if (confirm('Deseja remover permissão?')) {

                    const headers = this.Helpers.iniciarRequisicao();

                    const params = this.editedItem;

                    this.$store.dispatch("loading/addRequisicao",
                        AclAPI.delPermissao(headers, params)
                            .then(response => {

                                const token = response.data.token;
                                localStorage.setItem('token', token);

                                if (response.status == 200) {

                                    this.editedItem = {}

                                    this.initialize();

                                }

                            })
                            .catch(() => {
                                this.Helpers.logout();
                            })
                    )

                }else{
                    this.editedItem = {}
                }

            },

            close() {
                this.dialog = false
                setTimeout(() => {
                    this.editedItem = Object.assign({}, this.defaultItem)
                    this.editedIndex = -1
                }, 300)
            },

            save() {

                if (!this.$v.$invalid) {
                    const headers = this.Helpers.iniciarRequisicao();

                    const params = this.editedItem;

                    this.$store.dispatch("loading/addRequisicao",
                        AclAPI.addPermissao(headers, params)
                            .then(response => {

                                const token = response.data.token;
                                localStorage.setItem('token', token);

                                if (response.status == 200) {

                                    this.initialize();

                                }

                            })
                            .catch(() => {
                                this.Helpers.logout();
                            })
                    )

                    this.close()
                }
            },
        },
    }
</script>
<style scoped>
</style>